import { useEffect, useState } from 'react';

const countryCurrencyMap: Record<string, string> = {
  NG: 'NGN', GH: 'GHS', KE: 'KES', ZA: 'ZAR',
  UG: 'UGX', TZ: 'TZS', SN: 'XOF', CI: 'XOF', CM: 'XAF',
  US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'AUD',
  DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', PT: 'EUR', AT: 'EUR', IE: 'EUR',
  IN: 'INR', BR: 'BRL', MX: 'MXN', JP: 'JPY', CN: 'CNY',
};

export function useLocationCurrency(defaultCurrency = 'EUR') {
  const [currency, setCurrency] = useState<string>(defaultCurrency);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        const detected = data.country_code ? countryCurrencyMap[data.country_code] : undefined;
        if (detected) setCurrency(detected);
      })
      .catch(() => { /* silently fall back to default */ })
      .finally(() => setLoading(false));
  }, []);

  return { currency, loading };
}
